// Central configuration for all solar monitoring sites
// To add a new site, simply add a new object to the sites array

export const weatherConfig = {
  location: {
    name: 'Eugene, OR',
    lat: 44.0521,
    lon: -123.0868,
    timezone: 'America/Los_Angeles'
  },
  apiUrl: 'https://api.open-meteo.com/v1/forecast'
};

export const sites = [
  {
    id: 'willamette',
    name: 'Willamette High School',
    path: '/willamette',
    type: 'egauge',
    description: 'eGauge monitoring system with dual inverter setup',
    color: 'from-blue-500 to-purple-600',
    apiPath: '/api/egauge-show',
    backendPath: 'willamette',
    backendApiPath: '/api',
    egaugeUrl: 'https://egauge94820.egaug.es',
    registers: {
      power: 'gen',
      inverters: ['Inv 2 Power', 'Inv 1 Power'],
      voltages: ['Inv 1 L1 Voltage', 'Inv 1 L2 Voltage', 'Inv 1 L3 Voltage', 'Inv 2 L1 Voltage', 'Inv 2 L2 Voltage', 'Inv 2 L3 Voltage'],
      amperage: ['Inv 1 L1 Amperage', 'Inv 1 L2 Amperage', 'Inv 1 L3 Amperage', 'Inv 2 L1 Amperage', 'Inv 2 L2 Amperage', 'Inv 2 L3 Amperage'],
      defaultVisible: ['gen', 'Inv 2 Power']
    }
  },
  {
    id: 'kalapuya-cte',
    name: 'Kalapuya CTE',
    path: '/kalapuya-cte',
    type: 'egauge',
    description: 'eGauge monitoring with 4 DC solar arrays',
    color: 'from-green-500 to-emerald-600',
    apiPath: '/api/egauge-kalapuya',
    backendPath: 'kalapuya-cte',
    backendApiPath: '/api',
    egaugeUrl: 'https://egauge103842.d.egauge.net/ng/',
    registers: {
      power: 'Power',
      dcSolar: ['DC Solar 1', 'DC Solar 2', 'DC Solar 3', 'DC Solar 4'],
      voltages: ['L1 Voltage', 'L2 Voltage', 'L3 Voltage'],
      environmental: ['Internal Temperature', 'Internal Humidity'],
      defaultVisible: ['Power', 'DC Solar 1', 'DC Solar 2', 'DC Solar 3', 'DC Solar 4']
    }
  },
  {
    id: 'kalapuya-hs',
    name: 'Kalapuya High School',
    path: '/kalapuya-hs',
    type: 'enphase',
    description: 'Enphase solar monitoring system',
    color: 'from-orange-500 to-red-600',
    url: 'https://enlighten.enphaseenergy.com/web/u7au5927114/today/graph/custom?public=1',
    headerColor: 'from-blue-500 to-purple-600',
    buttonColor: 'blue'
  },
  {
    id: 'cascade-ms',
    name: 'Cascade Middle School',
    path: '/cascade-ms',
    type: 'solaredge',
    description: 'SolarEdge solar monitoring system',
    color: 'from-teal-500 to-cyan-600',
    url: 'https://monitoringpublic.solaredge.com/solaredge-web/p/site/public?name=Bethel_Cascade_Middle_School#/dashboard',
    headerColor: 'from-green-500 to-emerald-600',
    buttonColor: 'green',
    disableIframe: true // SolarEdge doesn't work properly in iframes
  }
];

// Helper function to get site by ID
export const getSiteById = (id) => sites.find(site => site.id === id);

// Helper function to get site by path
export const getSiteByPath = (path) => sites.find(site => site.path === path);

// Get all eGauge sites
export const getEGaugeSites = () => sites.filter(site => site.type === 'egauge');

// Get all external sites (Enphase, SolarEdge, etc.)
export const getExternalSites = () => sites.filter(site => site.type !== 'egauge');
